module.exports = { "default": require("core-js/library/fn/object/is-extensible"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/babel-runtime/core-js/object/is-extensible.js
// module id = 1137
// module chunks = 168707334958949